import { http } from "../client";
export var getAllDevices = function () {
    return http.api
        .get("devices")
        .then(function (response) { return response.data.data; })
        .then(function (devices) {
        return devices.map(function (_a) {
            var id = _a.id, title = _a.title, timetable_id = _a.timetable_id;
            return ({
                id: id,
                title: title,
                timetableId: timetable_id,
            });
        });
    });
};
